import React from 'react';
import { useRecoilState } from 'recoil';
import { Box, Grid } from '@mui/material';
import { studyNameState } from 'features/optimization/state/appConfigAtoms';
import { CustomTextField } from 'shared/ui/CustomTextField';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  label: string;
  labelXs?: number;
  fieldXs?: number;
}

export const StudyNameField: React.FC<Props> = ({
  label,
  labelXs = 5,
  fieldXs = 3,
}) => {
  const [appStudyName, setAppStudyName] = useRecoilState(studyNameState);

  const handleCfdNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAppStudyName(event.target.value); // Update the note state
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={labelXs}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <Grid item xs={fieldXs}>
          <CustomTextField
            required
            label="study name"
            variant="outlined"
            value={appStudyName} // Bind the value to the state
            onChange={handleCfdNoteChange} // Handle changes
          />
        </Grid>
      </Grid>
    </Box>
  );
};
